<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <mat-select [(ngModel)]="selected_business_type_id" (ngModelChange)="businesTypeValueChanged()"
        placeholder='Select Booth Type'
        style="border: 1px solid black; padding: 10px; border-radius: 11px; font-size: 22px;">
        <mat-option *ngFor="let business_type of business_types" [value]="business_type.id">
          {{business_type.name}}
        </mat-option>
      </mat-select>
    </div>
  </div><br>
  <div class="row" *ngIf="!is_data_available">
    <div class="col">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
      </mat-progress-spinner>
    </div>
  </div>
  <div class="row" *ngIf="is_data_available && selected_business_type_id !== null">
    <div class="col">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let product_group of by_product_group_list" style="margin-bottom: 1%;">
          <mat-expansion-panel-header style="padding: 30px;">
            <mat-panel-title>
              {{product_group['name']}} &nbsp; &nbsp; <i> Total Product :
                <span *ngIf="by_product_dict.hasOwnProperty(product_group['id'])">
                  {{by_product_dict[product_group['id']].length}}
                </span>
                <span *ngIf="!by_product_dict.hasOwnProperty(product_group['id'])">
                  0
                </span></i>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <table class="table table-dark">
            <thead>
              <tr>
                <th></th>
                <th>Base Price</th>
                <th>SGST Amount</th>
                <th>CGST Amount</th>
                <th>MRP</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let product of by_product_dict[product_group['id']]">
                <td scope="row">{{product['name']}}</td>
                <td
                  (click)="openDialog(selected_business_type_id, product['id'], product['name'], checkValueAvailableInDict(product['id'], 'base_price'), 'Base Price')">
                  {{checkValueAvailableInDict(product['id'], 'base_price')}}</td>
                <td
                  (click)="openDialog(selected_business_type_id, product['id'], product['name'], checkValueAvailableInDict(product['id'], 'cgst_amount'), 'CGST Amount')">
                  {{checkValueAvailableInDict(product['id'], 'cgst_amount')}}</td>
                <td
                  (click)="openDialog(selected_business_type_id, product['id'], product['name'], checkValueAvailableInDict(product['id'], 'sgst_amount'), 'SGST Amount')">
                  {{checkValueAvailableInDict(product['id'], 'sgst_amount')}}</td>
                <td
                  (click)="openDialog(selected_business_type_id, product['id'], product['name'], checkValueAvailableInDict(product['id'], 'mrp'), 'MRP')">
                  {{checkValueAvailableInDict(product['id'], 'mrp')}}</td>
              </tr>
            </tbody>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</section>
